module.exports = __webpack_public_path__ + "static/media/logo_emina_colored.4e6fc2ef.png";